import type { Generation } from '@paint-ai/shared';
import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { AppLayout } from '@/components/layout/AppLayout';
import { LoadingState } from '@/components/ui';
import { StudioPage, useStudio } from '@/features/studio';
import { paths } from './paths';

// History is a separate chunk: most sessions start (and often stay) in the studio.
const HistoryPage = lazy(() => import('@/features/history/HistoryPage').then((m) => ({ default: m.HistoryPage })));

/** Wires the history feature to the studio: "Apply settings" loads a generation and opens the studio. */
function HistoryRoute() {
  const { loadGeneration } = useStudio();
  const navigate = useNavigate();
  const apply = (generation: Generation) => {
    loadGeneration(generation);
    navigate(paths.studio);
  };
  return (
    <Suspense fallback={<LoadingState />}>
      <HistoryPage onApplyGeneration={apply} />
    </Suspense>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<StudioPage />} />
        <Route path={paths.history} element={<HistoryRoute />} />
        <Route path="*" element={<Navigate to={paths.studio} replace />} />
      </Route>
    </Routes>
  );
}
